import React from 'react';
import { compose, withPropsOnChange } from 'recompose';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';
import { TextField, Select } from 'redux-form-material-ui';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import { get, isArray } from 'lodash';
import { Autocomplete } from '../../../components/forms/Autocomplete';

const styles = (theme) => ({
  textFields: {
    width: '80%',
  },
});

const enhance = compose(
  withStyles(styles),
  connect((state) => ({
    userAttributes: get(state, 'app.userAttributes', []),
  })),
  withPropsOnChange(['userAttributes'], ({ userAttributes }) => {
    const userAttributesWithoutHeight = [];
    let userHeight = null;
    if (isArray(userAttributes)) {
      userAttributes.forEach((userAttribute) => {
        if (get(userAttribute, 'name') === 'Výška') {
          userHeight = { ...userAttribute };
        } else {
          userAttributesWithoutHeight.push(userAttribute);
        }
      });
    }

    return { userHeight, userAttributesWithoutHeight };
  }),
  reduxForm({ form: 'personForm' })
);

export default enhance(
  ({
    classes,
    handleSubmit,
    setAddPerson,
    userHeight,
    userAttributesWithoutHeight,
    setContact,
    setEditPerson,
  }) => (
    <form className={classes.form} onSubmit={handleSubmit}>
      <Grid container spacing={24}>
        <Grid item xs={3}>
          <Field
            name="forename"
            component={TextField}
            label="Jméno"
            className={classes.textFields}
          />
        </Grid>
        <Grid item xs={3}>
          <Field
            name="surname"
            component={TextField}
            label="Příjmení"
            className={classes.textFields}
          />
        </Grid>
      </Grid>
      <Grid container spacing={8}>
        {userAttributesWithoutHeight.map((item) => (
          <Grid key={item.id} item xs={3}>
            <FormControl className={classes.textFields}>
              <InputLabel htmlFor={item.name}>{item.name}</InputLabel>
              <Field
                name={`userAttributeValues.${item.id}`}
                component={Select}
                placeholder={item.name}
              >
                {item.values.map((item2) => (
                  <MenuItem key={item2.id} value={item2.id}>
                    {item2.value}
                  </MenuItem>
                ))}
              </Field>
            </FormControl>
          </Grid>
        ))}
        {userHeight && (
          <Grid item xs={3}>
            <React.Fragment>
              <Autocomplete
                name={`userAttributeValues.${userHeight.id}`}
                placeholder="Vyberte"
                options={userHeight.values.map((item2) => ({
                  label: item2.value,
                  value: item2.id,
                }))}
                label={userHeight.name}
                style={{ width: '80%' }}
              />
            </React.Fragment>
          </Grid>
        )}
      </Grid>
      <div style={{ marginTop: 20 }}>
        <Button type="submit" variant="contained" color="primary" className={classes.submit}>
          Uložit
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => {
            setAddPerson(false);
            setEditPerson(false);
            setContact(null);
          }}
        >
          Zrušit
        </Button>
      </div>
    </form>
  )
);



// WEBPACK FOOTER //
// ./src/modules/users/detail/personForm.js